module.exports = __webpack_public_path__ + "static/media/maximalist-bg-medium.cb832f6.webm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maximalist-bg-medium.webm
// module id = nh+Y
// module chunks = 0